import React from 'react';
import { IconButton, makeStyles } from '@material-ui/core';
import { OverflowMenuVertical } from '@carbon/icons-react';
import { annotationTimeFormatter } from '@utils/formatter';
import { CapaQuotationSpecificAnnotationComment } from '@generated/graphql';
import { CustomizedTypography } from '@components/Customized';
import { colorSet } from '@components/Provider';
import UserAvatar from './UserAvatar';

interface AnnotationCommentProps {
  comment: CapaQuotationSpecificAnnotationComment;
  isMyComment: boolean;
  popupRef: React.MutableRefObject<HTMLButtonElement | null>;
  setOpenControlPopup: React.Dispatch<React.SetStateAction<boolean>>;
}

const AnnotationDetailComment: React.FunctionComponent<AnnotationCommentProps> = ({
  comment,
  isMyComment,
  popupRef,
  setOpenControlPopup
}) => {
  const { authorInfo, commentContent } = useStyles();
  return (
    <>
      <div className={authorInfo}>
        <UserAvatar userName={comment.userName ?? ''} size={32} />
        <div className="name-and-time">
          <CustomizedTypography variant="body1" fontWeight="500">
            {comment.userName}
          </CustomizedTypography>
          <CustomizedTypography className="time" variant="subtitle2">
            {`${annotationTimeFormatter(
              (comment.updatedAt ? comment.updatedAt : comment.createdAt) ?? ''
            )} ${comment.edited ? '(수정됨)' : ''}`}
          </CustomizedTypography>
        </div>
        {isMyComment && (
          <IconButton
            className="comment-control-button"
            size="small"
            ref={popupRef}
            onClick={() => {
              setOpenControlPopup(true);
            }}
          >
            <OverflowMenuVertical size={20} color={colorSet.gray600} />
          </IconButton>
        )}
      </div>
      <div className={commentContent}>
        <CustomizedTypography variant="body1" color="textPrimary">
          {comment.comment}
        </CustomizedTypography>
      </div>
    </>
  );
};

export default AnnotationDetailComment;

const useStyles = makeStyles((theme) => ({
  authorInfo: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    '& .name-and-time': {
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      '& .time': {
        color: colorSet.gray500
      }
    },
    '& .comment-control-button': {
      marginLeft: 'auto'
    }
  },
  commentContent: {
    paddingLeft: '44px',
    paddingRight: '36px',
    '& > p': {
      wordBreak: 'break-all',
      whiteSpace: 'pre-line'
    }
  }
}));
